// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3Ktlx","content":"LoadingAlert_content__1zv_K"};